import { Grid, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column-reverse',
  },
  '& .PLSectionTitle': {
    color: theme.palette.common.white,
    marginBottom: theme.spacing(3.75),
    display: 'inline',
    wordBreak: 'break-word',
  },
  '& .PLSectionSubTitle': {
    color: theme.palette.common.white,
    marginBottom: theme.spacing(3.75),
    marginTop: 0,
    display: 'block',
    wordBreak: 'break-word',
  },
  '& .PLExternalLinkIcon': {
    width: theme.spacing(3),
    height: theme.spacing(3),
    cursor: 'pointer',
    display: 'inline-block',
    marginLeft: theme.spacing(0.5),
    marginTop: theme.spacing(0.6),
    '& svg': {
      width: '100%',
      height: '100%',
      display: 'block',
    },
  },
  '& .PLMapSide': {
    height: '100%',
    width: '100%',
    [theme.breakpoints.down('lg')]: {
      height: theme.typography.pxToRem(500),
    },
    [theme.breakpoints.down('md')]: {
      height: theme.typography.pxToRem(290),
    },
  },
  '& .PLMapPlaceholder': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  '& .PLLocationsList': {
    height: theme.typography.pxToRem(445),
    overflowY: 'auto',
    [theme.breakpoints.down('lg')]: {
      maxHeight: theme.typography.pxToRem(445),
    },
    '&::-webkit-scrollbar': {
      width: theme.spacing(1.25),
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: theme.spacing(0.5),
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.background.secondary,
      borderRadius: theme.spacing(0.5),
      '&:hover': {
        background: theme.palette.background.tertiary,
      },
    },

    [theme.breakpoints.down('md')]: {
      height: 'auto',
      maxHeight: theme.typography.pxToRem(560),
    },
    '& .MuiAccordion-root': {
      marginTop: 0,
    },
  },

  '& .PLSearchInputContainer': {
    background: theme.palette.secondary.dark,
    marginTop: theme.spacing(3.75),
    backdropFilter: `blur(${theme.spacing(1)})`,
    display: 'flex',
    height: theme.typography.pxToRem(56),
    borderRadius: theme.spacing(0.5),
    marginBottom: theme.spacing(4),
  },

  '& .PLSearchIconWrapper': {
    padding: theme.spacing(2),
    borderRadius: theme.spacing(0, 0.5, 0.5, 0),
    width: theme.spacing(7),
    background: `linear-gradient(180deg, ${alpha(
      theme.palette.common.white,
      0.1,
    )} 0%,  ${alpha(theme.palette.common.white, 0)}100%), ${theme.palette.primary.main
      }`,
    boxShadow: `0px 2px 2px 0px ${alpha(
      theme.palette.common.white,
      0.25,
    )} inset, 0px -2px 2px 0px ${alpha(theme.palette.common.black, 0.1)} inset`,
    color: theme.palette.common.black,
    fontSize: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  '& .PLInput': {
    height: '100%',
    border: `2px solid ${theme.palette.divider[7]}`,
    borderRadius: theme.spacing(0.5, 0, 0, 0.5),
    borderRight: 0,
    '& .MuiInputBase-root ': {
      height: '100%',
    },
    '& .MuiInputBase-input': {
      padding: theme.spacing(2, 3, 1.5, 3),
      fontSize: theme.spacing(2),
      lineHeight: '150%',
      color: theme.palette.common.white,
    },
    '& fieldset': {
      border: 0,
      height: '100%',
    },
    '& input::placeholder': {
      color: theme.palette.common.white,
      opacity: 1,
    },
  },
}));
export default StyledGrid;